import { HeartIcon } from '@syconium/little-miss-figgy'

import { useFavorites } from '../../../app/_providers/FavoritesProvider.client'
import { NavTab } from '../../../types/graphql'

export function useFavoritesTab(): NavTab | null {
  const { enabled: favoritesEnabled } = useFavorites()

  if (!favoritesEnabled) return null

  return {
    __typename: 'NavTab',
    ariaLabel: 'Favorites',
    href: '/favorites',
    id: 'favorites',
    render: () => {
      return <HeartIcon />
    },
    sections: [],
    text: '',
    textColor: null,
    wrapperElement: undefined,
    alternateModelVariant: null,
  }
}
